import React, { Fragment } from 'react';
import { Table } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import type { ColumnsType } from "antd/es/table";
import TablePagination from "../TablePagination";

import { formatDateToFullString } from "../../util/date";
import ProductChangeResponse from "../../types/ProductChangeResponse";
import ProductChangeFromOtherDTO from "../../types/ProductChangeFromOtherDTO";
import { useTexts } from "../../hooks/useTexts";

const ProductChangeFromOtherTable = ({ data, onPageChange }: {
    data: ProductChangeResponse<ProductChangeFromOtherDTO>,
    onPageChange: (page: number, pageSize: number) => void
}): JSX.Element => {
    const { t } = useTexts();

    const columns: ColumnsType<ProductChangeFromOtherDTO> = [
        {
            title: '#',
            key: 'index',
            render: (text, record, index) => ((data.pagination.page - 1) * data.pagination.pageSize) + index + 1,
            width: 60,
        },
        {
            title: t('productChange', 'doctorWhoChanged'),
            dataIndex: 'productChanger',
            key: 'productChanger',
            render: text => text || "-"
        },
        {
            title: t('productChange', 'otherProduct'),
            key: 'otherProduct',
            render: (_, record) => record.initialProduct?.name || "-"
        },
        {
            title: t('productChange', 'initialAssignment'),
            dataIndex: 'initialMedic',
            key: 'initialMedic',
            render: text => text || "-"
        },
        {
            title: t('productChange', 'ourProduct'),
            key: 'ourProduct',
            render: (_, record) => record.prescription.product?.name
        },
        {
            title: t('productChange', 'childMonth'),
            dataIndex: 'childMonth',
            key: 'childMonth',
        },
        {
            title: t('mediator', 'placeObject'),
            key: 'placeObject',
            render: (_, record) => record.prescription.mediator?.place?.name || "-"
        },
        {
            title: t('prescription', 'contactNumber'),
            key: 'contactNumber',
            render: (_, record) => (
                <>
                    {record.prescription.phoneNumber}
                    <br />
                    {record.prescription.additionalPhoneNumber}
                </>
            )
        },
        {
            title: t('prescription', 'user'),
            key: 'user',
            render: (_, record) => record.prescription.user.username
        },
        {
            title: t('prescription', 'createdAt'),
            key: 'createdAt',
            render: (_, record) => record.createdAt ? formatDateToFullString(record.createdAt) : "-"
        },
        {
            title: '',
            key: 'view',
            render: (_, record) => (
                <Link to={"/prescriptions/" + record.prescription.id} target="_blank" rel="noopener noreferrer">
                    <EyeOutlined style={{ fontSize: '20px', color: '#4F46E5' }} />
                </Link>
            ),
            width: 50,
        }
    ];

    return (
        <Fragment>
            <div style={{ background: 'white', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                <Table
                    columns={columns}
                    dataSource={data.items}
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                    pagination={false}
                />
                <TablePagination
                    current={data.pagination.page}
                    pageSize={data.pagination.pageSize}
                    pageCount={data.pagination.pageCount}
                    total={data.pagination.elementCount}
                    onChange={onPageChange}
                />
            </div>
        </Fragment>
    );
};

export default ProductChangeFromOtherTable;